const formClass = (block, element = null, modifiers = []) => {
    const baseClass = !!element ?
        `${block}__${element}` :
        block

    return Object.keys(modifiers)
        .filter(key => modifiers[key] !== false)
        .map(key =>
            typeof modifiers[key] === 'boolean'
                ? `${baseClass}--${key}`
                : `${baseClass}--${key}_${modifiers[key]}`
        )
        .concat(baseClass)
        .reverse()
        .join(' ')
}

export default block => (...args) => {
    if (args.length === 2) {
        return formClass(block, args[0], args[1])
    }

    if (typeof args[0] === 'object') {
        return formClass(block, null, args[0])
    }

    if (typeof args[0] === 'string') {
        return formClass(block, args[0])
    }

    return formClass(block)
}


// WEBPACK FOOTER //
// ./src/utils/bemClass.js